import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';

import { SurveyCertificate } from 'services/survey';
import { getAccessToken } from 'utils/authentication';
import { PROFILE_DETAIL_ERROR } from '@core/constants/Errors';

import ContentCertificate from 'components/common/contentcertificate/ContentCertificate';
import Survey from 'components/pages/lecture/lecturemainbutton/survey/Survey';
import Loading from '@core/components/loading/Loading';
import UserFullName from 'components/common/userfullname/UserFullName';

import classes from './SurveyCertificateWrapper.module.scss';



const SurveyCertificateWrapper = () => {
    const router = useRouter();
    const courseId = router.query.slug[0];
    const [surveyStatus, setSurveyStatus] = useState(true);
    const [hasName, setHasName] = useState(true);
    const { data, isLoading, refetch } = useQuery(['get-certificate-survey', getAccessToken()], () => SurveyCertificate.GET(courseId), {
        onError: (error) => {
            if (error?.response?.status === +PROFILE_DETAIL_ERROR) {               
                setHasName(false);
            }
        },
    });

    const fullnameModalHandler = () => {
        setHasName(true);
        refetch();
    }


    return (
        <>
            <div className={`${classes['certificate-modal']} d-flex flex-column justify-content-center`}>
                {isLoading ?
                    <Loading /> :
                    <>
                        {(data?.data && Object.keys(data.data).length !== 0 && !isLoading && surveyStatus) ?
                            <Survey survey={data.data} setSurveyStatus={setSurveyStatus} />
                            :
                            <>
                                {hasName ? (
                                    <ContentCertificate content_type="lecture" />
                                ) : (
                                    <UserFullName
                                        title=""
                                        description="We need your name to continue. Enter your name below. Please note that your name is not editable later"
                                        callback={fullnameModalHandler}
                                    />
                                )}
                            </>
                        }
                    </>}
            </div>
        </>

    );
};

export default SurveyCertificateWrapper;